import React, { Fragment, useEffect, useMemo, useState } from "react";
//Components
import { HeaderContentBar } from "components/Layout";
import { AlertMessage } from "components/UI";
import { Box, Grid } from "@mui/material";
import CriterialBar from "pages/Common/Monitoring/LogMonitoringScreen/LogMonitoringSummaryScreen/components/CriterialBar";
import SubCriterialBar from "pages/Common/Monitoring/LogMonitoringScreen/LogMonitoringSummaryScreen/components/SubCriterialBar";
import ButtonBar from "pages/Common/Monitoring/LogMonitoringScreen/LogMonitoringSummaryScreen/components/ButtonBar";
import TableBar from "pages/Common/Monitoring/LogMonitoringScreen/LogMonitoringSummaryScreen/components/TableBar";
//Hooks
import useColumn from "./hooks/useColumn";
import useLocalStorage from "shared/hooks/useLocalStorage";
// Utils
// import { messageDisplay, responseErrors } from "utils";
// Service
import {
  useLogMonitorGetModuleQuery,
  useLogMonitorGetFunctionQuery,
  useLogMonitorGetLogStatusQuery,
  // useLogSummarySearchMutation,
} from "shared/services/common/monitoring";
// Type
import { API_LOG_MONITORING, COMMON_ENUM, DEFAULT_LOCAL_STATE } from "shared/constants";
import { ModeAction } from "state/enum";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { isBlankOrNull } from "utils";
const LogMonitoringSummaryScreen = () => {
  const functionId = "WSTD3010";
  const dateTime = useSelector(state => state.common.dateTime);
  const [logDetail, setLogDetail] = useLocalStorage("logDetail", DEFAULT_LOCAL_STATE);
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const [mode, setMode] = useState(ModeAction.VIEW);

  const [onSearch, setOnSearch] = useState(false);

  const [msgError, setMsgError] = useState([]);
  const [msgAlert, setMsgAlert] = useState([]);

  const [searchForm, setSearchForm] = useState({
    [API_LOG_MONITORING.DATA_OWNER]: COMMON_ENUM.C_SM_CTG_TMAP_EM,
    [API_LOG_MONITORING.MODULE_ID]: "",
    [API_LOG_MONITORING.FUNCTION_ID]: "",
    [API_LOG_MONITORING.STATUS_ID]: "",
    [API_LOG_MONITORING.LEVEL_ID]: "",
    [API_LOG_MONITORING.USER_ID]: "",
    [API_LOG_MONITORING.APP_ID]: "",
    [API_LOG_MONITORING.DATE_FORM]: isBlankOrNull(dateTime)
      ? dayjs().format("DD/MM/YYYY")
      : dayjs(dateTime, COMMON_ENUM.DATETIME_FORMAT).format("DD/MM/YYYY"),
    [API_LOG_MONITORING.DATE_TO]: isBlankOrNull(dateTime)
      ? dayjs().format("DD/MM/YYYY")
      : dayjs(dateTime, COMMON_ENUM.DATETIME_FORMAT).format("DD/MM/YYYY"),
  });
  // pagination
  const [pagination, setPagination] = useState({});
  const [pageNumber, setPageNumber] = useState(1);

  // api
  const { data: moduleData } = useLogMonitorGetModuleQuery();
  const { data: functionData } = useLogMonitorGetFunctionQuery(searchForm?.moduleId ? searchForm?.moduleId : "all");

  const cdOrder = { PS: 1, I: 2, W: 3, E: 4, F: 5 };
  let { data: logStatusData } = useLogMonitorGetLogStatusQuery();
  logStatusData?.sort((a, b) => cdOrder[a.cd] - cdOrder[b.cd]);

  // const searchSummary = useLogSummarySearchMutation();

  const handleTabLogDetail = row => {
    const logData = {
      dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
      moduleId: row?.moduleId,
      functionId: row?.functionId,
      statusId: row?.statusId,
      userId: row?.userId,
      appId: row?.appId,
      dateFrom: row?.startDate ? row?.startDate : null,
      dateTo: row?.endDate ? row?.endDate : null,
      levelId: "",
    };

    setLogDetail(logData);
    window.open("/common/monitoring/log-monitoring-detail", "_blank");

    // handleSearchData(logData);
  };

  // columns
  // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps
  const columns = useMemo(() => useColumn({ rows, mode, handleTabLogDetail }), [rows, mode]);

  useEffect(() => {
    if (dateTime) {
      setSearchForm(prev => ({
        ...prev,
        [API_LOG_MONITORING.DATE_FORM]: dayjs(dateTime, COMMON_ENUM.DATETIME_FORMAT).format("DD/MM/YYYY"),
        [API_LOG_MONITORING.DATE_TO]: dayjs(dateTime, COMMON_ENUM.DATETIME_FORMAT).format("DD/MM/YYYY"),
      }));
    }
  }, [dateTime]);

  return (
    <Fragment>
      <Box sx={{ padding: "1rem 1rem 0 1rem" }}>
        <HeaderContentBar title="WSTD3010 : Log Monitoring Summary Screen" />
        <AlertMessage type={"warning"} message={msgError} />
        <AlertMessage type={"success"} message={msgAlert} />
        <Grid container spacing={1} sx={{ alignItems: "center", mt: "1px" }}>
          <CriterialBar
            searchForm={searchForm}
            setSearchForm={setSearchForm}
            datalist={{ moduleData, functionData, logStatusData }}
          />
        </Grid>
        <Grid container spacing={1} sx={{ alignItems: "center" }}>
          <SubCriterialBar searchForm={searchForm} setSearchForm={setSearchForm} />
        </Grid>
      </Box>
      <Box>
        <ButtonBar
          setMode={setMode}
          setRows={setRows}
          searchForm={searchForm}
          setSearchForm={setSearchForm}
          // setLogSummary={setLogSummary}
          setLogDetail={setLogDetail}
          setOnSearch={setOnSearch}
          setRowModesModel={setRowModesModel}
          setRowSelectionModel={setRowSelectionModel}
          setMsg={{ setMsgError, setMsgAlert }}
          pagination={{ pagination, setPagination, pageNumber, setPageNumber }}
          functionId={functionId}
        />
      </Box>
      <Box sx={{ padding: "0 1rem 0.5rem 1rem" }}>
        {/* <Grid container spacing={2}> */}
        {onSearch && (
          <TableBar
            searchForm={searchForm}
            mode={mode}
            setMode={setMode}
            onSearch={onSearch}
            rows={rows}
            setRows={setRows}
            columns={columns}
            setMsg={{ setMsgError, setMsgAlert }}
            pagination={{ pagination, setPagination, pageNumber, setPageNumber }}
            rowSelection={{ rowSelectionModel, setRowSelectionModel, rowModesModel, setRowModesModel }}
          />
        )}
        {/* </Grid> */}
      </Box>
    </Fragment>
  );
};

export default LogMonitoringSummaryScreen;
